import {
    ILoadableArray,
    Loadable,
    createDefaultILoadableArray,
    createDefaultLoadable,
} from '../../models/loadable';
import {
    IPatrolTemplate,
    IPatrolSchedule,
    IPatrolRoute,
    IPatrolRouteCamera,
    IPatrolRun,
    IPatrolRunFilter,
    PatrolRunFilterKey,
    IPatrolFinding,
    IPatrolDataPoint,
} from '../../models/patrol.interface';

export interface PatrolState {
    templates: ILoadableArray<IPatrolTemplate>;
    schedules: ILoadableArray<IPatrolSchedule>;
    routes: ILoadableArray<IPatrolRoute>;
    routeCameras: ILoadableArray<IPatrolRouteCamera> & { routeId: string | null };
    runs: ILoadableArray<IPatrolRun>;
    runsFilter: IPatrolRunFilter;
    runsAddedFilters: PatrolRunFilterKey[];
    selectedRun: Loadable & { run: IPatrolRun | null };
    allFindings: ILoadableArray<IPatrolFinding>;
    findings: ILoadableArray<IPatrolFinding> & { runId: string | null };
    dataPoints: ILoadableArray<IPatrolDataPoint> & { templateId: string | null };
    saving: Loadable;
    savingCameras: Loadable;
    savingDataPoints: Loadable;
    licensedCameras: ILoadableArray<string> & { siteId: string | null };
}

export const initialPatrolState: PatrolState = {
    templates: createDefaultILoadableArray<IPatrolTemplate>(),
    schedules: createDefaultILoadableArray<IPatrolSchedule>(),
    routes: createDefaultILoadableArray<IPatrolRoute>(),
    routeCameras: { ...createDefaultILoadableArray<IPatrolRouteCamera>(), routeId: null },
    runs: createDefaultILoadableArray<IPatrolRun>(),
    runsFilter: {
        dateRange: null,
        route_id: [],
        schedule_id: [],
        site_id: [],
        status: [],
    },
    runsAddedFilters: ['dateRange', 'status'],
    selectedRun: { ...createDefaultLoadable(), run: null },
    allFindings: createDefaultILoadableArray<IPatrolFinding>(),
    findings: { ...createDefaultILoadableArray<IPatrolFinding>(), runId: null },
    dataPoints: { ...createDefaultILoadableArray<IPatrolDataPoint>(), templateId: null },
    saving: createDefaultLoadable(),
    savingCameras: createDefaultLoadable(),
    savingDataPoints: createDefaultLoadable(),
    licensedCameras: { ...createDefaultILoadableArray<string>(), siteId: null },
};
